<template>
    <header id="Header" v-if="isWorkflowportal || isMobile">
        <div class="left">
            <div v-if="isMobile" class="hamburger-menu">
                <button @click="toggleMenu">
                    <Icon name="hamburger-menu" />
                </button>
            </div>
            <div v-if="isWorkflowportal" class="logocontainer" @click.prevent="handleHome">
                <div class="left" :data-label="env('version_label') || null">
                    <Logo />
                </div>
                <Back v-if="!isHome && !isMobile" />
            </div>
        </div>
        <div class="right" v-if="isMobile">
            <Profile />
            <!--<Notification />-->
            <!--<Menu />-->
        </div>
    </header>
</template>

<script>
import Notification from "elements/notification";
import Profile from "elements/profile";
import Menu from "elements/menu";

import { defineComponent, ref, watch, inject, computed  } from "vue";
import { useRoute, useRouter } from "vue-router";
import trans from "helpers/_translation";
import Icon from "components/icon";

import { isMobile } from "helpers/_device";

// Components
import Back from "layout/general/back";
import Logo from "layout/general/logo";

import {env} from "config";

export default defineComponent({
    name: "headerElement",
    components: {
        Logo,
        Icon,
        Back,
        Profile,
        Notification,
        Menu,
    },
    setup(props, { emit }) {

        const isWorkflowportal = inject("isWorkflowportal");

        const route = useRoute();
        const router = useRouter();

        const toggleMenu = () => {
            // Emit een event naar de bovenliggende component
            emit("toggleMenu");
        };

        const handleHome = () => {
            router.push("/");
        };

        const isHome = computed(() => {
            return route.path === "/";
        });

        return {
            env,
            trans,
            isMobile,
            toggleMenu,
            handleHome,
            isWorkflowportal,
            isHome
        };
    },
});
</script>
